export default "__VITE_ASSET__C26PUT12__"